import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import  firebase  from 'firebase';
//import { AngularFireDatabase } from 'angularfire2/database';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { FirebaseProvider } from '../providers/firebase/firebase';
//import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AgencyPage } from '../pages/home/agency/agency';
import { AdminPage } from '../pages/home/admin/admin';
import { ContactPage } from '../pages/home/contact/contact';
import { AnnoncePage } from '../pages/home/annonce/annonce';
//import { SellsPage } from '../pages/home/sells/sells';
import { BaremePage } from '../pages/home/bareme/bareme';
import { NosbiensPage } from '../pages/home/nosbiens/nosbiens';
import { PartnerPage } from '../pages/home/partner/partner';
import { DatabaseProvider } from '../providers/database/database';
import { Deeplinks } from '@ionic-native/deeplinks';
import { HttpClientModule } from '@angular/common/http';
import { IonicSelectableModule } from 'ionic-selectable';
import {FileOpener} from '@ionic-native/file-opener/ngx';
    // Initialize Firebase
   
    
    var config = {
      apiKey: "AIzaSyCFf5-R6SOZzRmk2MCFpS4_B-wDUOmRGq4",
      authDomain: "lionelmortier.immo",
      databaseURL: "https://lmimmosite.firebaseio.com",
      projectId: "lmimmosite",
      storageBucket: "lmimmosite.appspot.com",
      messagingSenderId: "153229491919"
    };
    firebase.initializeApp(config);
  
  /*const messaging = firebase.messaging();
  messaging.requestPermission().then(()=>{
    console.log('Message Permission')
  }).catch((err)=>{
    console.log(err)
  })*/


@NgModule({
  declarations: [
    MyApp,
    
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    IonicSelectableModule,
    
   // AngularFireDatabaseModule,
    

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    FirebaseProvider,
    DatabaseProvider,
    Deeplinks,
    FileOpener,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts